<div class="container-fluid section pt-3 pb-3 pr-0">
    <div class="d-flex flex-row justify-content-between mb-2 mr-3">
        <span class="header">Chats</span>
        <img src="../../../../../../assets/Images/arrow-cross.svg" class="icon" [routerLink]="['/chat']">
    </div>
    <div *ngIf="chatList.length" class="pr-3" [ngClass]="{'section-midwife': authService.user?.userType==userType.MIDWIFE, 'section-mum': authService.user?.userType==userType.MUM}">
        <div *ngFor="let person of chatList; let i = index" [routerLink]="['/chat']" [queryParams]="{ roomId: person.roomId}"
            class="icon">
            <div class="d-flex flex-row mt-3" *ngIf="person.mum">
                <div class="img-section">
                    <img class="profile-img" *ngIf="person.mum?.profileImage" [src]="person.mum?.profileImage">
                    <img class="profile-img" *ngIf="!person.mum?.profileImage"
                        src="../../../../../../assets/Images/pro-pic.png">
                </div>
                <div class="d-flex flex-column ml-3 excess-content w-100">
                    <div class="d-flex flex-row justify-content-between">
                        <span class="title flex-grow">{{person.mum?.name}}</span>
                        <span class="notify-time ml-2" *ngIf="person.timestamp!=undefined">{{person.timestamp | timeago}}</span>
                    </div>
                    <span class="sub-title pr-2">{{person.lastMessage}}</span>
                </div>
            </div>
            <div class="d-flex flex-row my-3" *ngIf="person.midwife">
                <div class="img-section">
                    <img class="profile-img" *ngIf="person.midwife?.profileImage" [src]="person.midwife?.profileImage">
                    <img class="profile-img" *ngIf="!person.midwife?.profileImage"
                        src="../../../../../../assets/Images/pro-pic.png">
                </div>
                <div class="d-flex flex-column ml-3 excess-content w-100">
                    <div class="d-flex flex-row justify-content-between">
                        <span class="title flex-grow">{{person.midwife?.name}}</span>
                        <span class="notify-time ml-2" *ngIf="person.timestamp!=undefined">{{person.timestamp | timeago}}</span>
                    </div>
                    <span class="sub-title pr-2">{{person.lastMessage}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="no-data" *ngIf="!chatList.length && !loading">
        <img class="align-self-center" src="../../../../../../assets/Images/NoDocuments.png" height="50" width="80"
            alt="No Chats">
        <span>No chats</span>
    </div>
</div>